import { Navigate, useLocation } from "react-router-dom";
import OrderPage from "./OrderPage";
import { CART_ORDERING_ENABLED, orderRedirectTarget } from "@/lib/ordering";

/** /order: the cart while online ordering is on, else the form-first wizard (#1221). */
export default function OrderRoute() {
  const location = useLocation();
  if (CART_ORDERING_ENABLED) return <OrderPage />;
  return <Navigate replace to={orderRedirectTarget(location.search)} />;
}
